/** Canonical sponsor_type values (matches API / sponsor research job). */
export const SPONSOR_TYPES = [
  "Institutional Managers",
  "Specialist Operators",
  "Mid-Market & Regional Sponsors",
  "Private Capital / HNWI Sponsors",
  "Other",
] as const;

export type SponsorType = (typeof SPONSOR_TYPES)[number];

export const SPONSOR_TYPE_UNASSIGNED_LABEL = "Unassigned";

export const SPONSOR_TYPE_OPTIONS: readonly string[] = SPONSOR_TYPES;
